import React from 'react';
import { SPACING_CARD, SPACING_HERO } from '../constants/layout';

export default function Loading({ message = "Loading…" }) {
  return (
    <div
      style={{
        width: '100%',
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--color-background)',
        padding: `${SPACING_HERO} ${SPACING_CARD}`,
        boxSizing: 'border-box',
      }}
    >
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid var(--color-border)',
        borderTop: '3px solid var(--color-accent)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <p style={{
        marginTop: SPACING_CARD,
        fontSize: '16px',
        color: 'var(--color-text-secondary)',
        margin: `${SPACING_CARD} 0 0 0`
      }}>
        {message}
      </p>
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
